import ReactCreateClass from 'create-react-class';
import selectHelper from './selectHelper';

import logError from 'App/babel/helpers/logError';
import RequestBuilder from 'Resources/RequestBuilder';
import AppService from 'App/legacy/AppService';
import { buildProductTree } from 'App/helpers/productTree';

var render = function () {
	return selectHelper.getInputComponent(this);
};

var componentDidMount = function (self) {
	var Product = window.Tools.Product;
	var dontUseCachedProducts = AppService.getTotals('products') > 4000;
	var customerId = AppService.getCustomerId();
	const extraValues = self.props.extraValues ?? [];

	var defaultSelect2Options = {
		// eslint-disable-next-line no-shadow-restricted-names
		matcher: function (term, undefined, object) {
			return object.name && object.name.toLowerCase().indexOf(term.toLowerCase()) !== -1;
		},
		initSelection: function (element, callback) {
			let value;
			const selectedOption = element.data?.('select2')?.selection?.data?.('select2-data') ?? self.props.value;

			if (self.props.multiple) {
				// Handle the case when selectedOption is an array (for multi-select2)
				if (selectedOption.length > 0) {
					// Separate extraValues from regular products
					const extraValueIds = extraValues.map(ev => ev.id);
					const selectedExtraValues = selectedOption.filter(opt => extraValueIds.includes(opt.id));
					const regularOptions = selectedOption.filter(opt => !extraValueIds.includes(opt.id));

					if (regularOptions.length > 0) {
						const rb = new RequestBuilder();
						rb.addFilter(
							Product.attr.id,
							rb.comparisonTypes.In,
							regularOptions.map(option => option.id)
						);

						Product.customer(customerId)
							.find(rb.build())
							.then(res => {
								if (res && res.data) {
									// Merge extraValues with fetched products
									const matchedExtraValues = extraValues.filter(ev =>
										selectedExtraValues.some(sev => sev.id === ev.id)
									);
									callback([...matchedExtraValues, ...res.data]);
								}
							})
							.catch(err => logError(err, 'Could not get products'));
					} else if (selectedExtraValues.length > 0) {
						// All selected values are extraValues
						const matchedExtraValues = extraValues.filter(ev =>
							selectedExtraValues.some(sev => sev.id === ev.id)
						);
						callback(matchedExtraValues);
					}
				}
			} else if (typeof selectedOption === 'object' && selectedOption && selectedOption.id) {
				// Check if selectedOption is an extraValue
				const matchedExtraValue = extraValues.find(ev => ev.id === selectedOption.id);
				if (matchedExtraValue) {
					callback(matchedExtraValue);
					return;
				}
				if (
					selectedOption.name &&
					selectedOption.currencies &&
					selectedOption.tiers &&
					selectedOption.listPrice !== undefined
				) {
					// We have all fields that we need so we can skip the fetch
					callback(selectedOption);
					return;
				}
				value = selectedOption.id;
			} else if (typeof element.val() === 'string') {
				// eslint-disable-next-line no-useless-escape
				value = element.val().replace(/\"/g, '');
			}

			if (value) {
				// Check if value is an extraValue id
				const matchedExtraValueById = extraValues.find(ev => String(ev.id) === String(value));
				if (matchedExtraValueById) {
					callback(matchedExtraValueById);
					return;
				}
				Product.customer(customerId)
					.get(value, self.props.usePriceLists)
					.then(function (res) {
						if (res && res.data) {
							callback(res.data);
						}
					})
					.catch(err => logError(err, 'Could not get product'));
			}
		}
	};

	var opts = {
		multiple: self.props.multiple || false,
		required: self.props.required || false,
		disabled: self.props.disabled || false,
		ajax: false,
		asIds: false,
		onChange: function (value) {
			if (Array.isArray(value)) {
				value = _.map(value, function (v) {
					return _.omit(v, ['$$parent']);
				});
			} else if (value && value.$$parent) {
				value = _.omit(value, ['$$parent']);
			}
			self.props.onChange(value);
		},
		idAttr: Product.attr.id,
		titleAttr: Product.attr.name,
		sorting: { field: Product.attr.name, ascending: true },
		placeholder: self.props.placeholder,
		select2: Object.assign(defaultSelect2Options, self.props.select2),
		excludeBundles: self.props.excludeBundles,
		excludeRecurring: self.props.excludeRecurring,
		excludeOneOffs: self.props.excludeOneOffs,
		fields: ['id', 'name', 'currencies', 'tiers', 'listPrice']
	};

	if (dontUseCachedProducts) {
		opts.ajax = true;
		opts.resource = Product;
		opts.ignoreMaxLimitCheck = opts.excludeRecurring || opts.excludeOneOffs;
		const extraValues = self.props.extraValues ?? [];
		// Set extraValues as initial data so they show when dropdown opens with empty search
		opts.data = extraValues;
		opts.getter = function (customerId, filter, searchTerm) {
			const excludeBundlesQuery = opts.excludeBundles ? [{ a: 'bundlePriceAdjustment', c: 'eq', v: null }] : [];
			const excludeRecurringQuery = opts.excludeRecurring ? [{ a: 'isRecurring', c: 'eq', v: false }] : [];
			const excludeOneOffsQuery = opts.excludeOneOffs ? [{ a: 'isRecurring', c: 'eq', v: true }] : [];

			return Product.customer(customerId)
				.find({
					...filter,
					usePriceLists: self.props.usePriceLists,
					q: [...(filter?.q ?? []), ...excludeBundlesQuery, ...excludeOneOffsQuery, ...excludeRecurringQuery]
				})
				.then(function (res) {
					if (extraValues.length) {
						let filteredExtraValues = extraValues;
						if (searchTerm) {
							const term = searchTerm.toLowerCase();
							filteredExtraValues = extraValues.filter(function (item) {
								return item.name && item.name.toLowerCase().indexOf(term) !== -1;
							});
						}
						const existingIds = res.data.map(function (item) {
							return item.id;
						});
						const uniqueExtraValues = filteredExtraValues.filter(function (item) {
							return !existingIds.includes(item.id);
						});
						res.data = [...uniqueExtraValues, ...res.data];
					}
					return res;
				});
		};
	} else {
		opts.data = function () {
			var onlyActive = true;
			var skipAuth = false;
			var selectableCategories = self.props.selectableCategories || false;
			var data = buildProductTree(
				onlyActive,
				skipAuth,
				selectableCategories,
				self.props.usePriceLists,
				opts.excludeBundles
			);
			// Merge extraValues if provided
			const extraValues = self.props.extraValues ?? [];
			return [...data.data, ...extraValues];
		};
	}

	var input = jQuery(self._input);

	selectHelper.getSelect2Options(self, opts, input, function (options) {
		const removeExcludedProducts = data => {
			return data
				.filter(product => {
					if (product.children) {
						return true;
					}
					if (opts.excludeRecurring && product.isRecurring) {
						return false;
					}
					if (opts.excludeOneOffs && !product.isRecurring) {
						return false;
					}
					if (opts.excludeBundles && product.bundlePriceAdjustment !== null) {
						return false;
					}
					return true;
				})
				.map(option => {
					if (option.children) {
						return { ...option, children: removeExcludedProducts(option.children) };
					}
					return option;
				})
				.filter(option => {
					if (option.children && !option.children.length) {
						return false;
					}
					return true;
				});
		};
		if (options.data) {
			options.data = removeExcludedProducts(options.data);
		}
		input.select2(options);
	});
};

const upProducts = ReactCreateClass({
	componentDidMount: function () {
		componentDidMount(this, false);
	},
	componentDidUpdate: selectHelper.updateValue,
	render: render
});

export default upProducts;
